import React from "react";

/**
 * @param {String} image - Path to the image
 * @param {String} name - Assignment name
 * @param {String} schedule - Assignment schedule info
 * @param {String} link - External link
 * @param {String} description - Description text
 */

function Assignment({ name, schedule, image, description, link }) {
  return (
    <div className="assignment">
      <h1 className="section-header">{name}</h1>
      <h2 className="sub-header">{schedule}</h2>

      <div className="assignment-grid">
        <a href={link} target="_blank" rel="noopener noreferrer">
          <div
            className="assignment-image"
            style={{ backgroundImage: `url("${image}")` }}
          ></div>
        </a>

        <p className="assignment-description">{description}</p>
      </div>
    </div>
  );
}

export default Assignment;
